import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ExpandableLabelHeader from './ExpandableLabelHeader';
import ExpandableLabelBody from './ExpandableLabelBody';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var ExpandableLabel = function ExpandableLabel(_ref) {
  var className = _ref.className,
      expanded = _ref.expanded,
      floating = _ref.floating,
      roundedCorners = _ref.roundedCorners,
      zIndex = _ref.zIndex,
      children = _ref.children;
  var wrapperEl = useRef(null);

  var _useState = useState(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var classes = classnames("ptr-ExpandableLabel ".concat(className || ''), {
    'is-expanded': isExpanded,
    'is-floating': floating,
    'is-rounded': roundedCorners
  });
  useOnClickOutside(wrapperEl, function () {
    return setExpanded(false);
  });
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    style: {
      zIndex: zIndex ? zIndex : 0
    },
    ref: wrapperEl,
    children: React.Children.map(children, function (child) {
      if (child.type === ExpandableLabelHeader) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          onExpand: setExpanded,
          expanded: isExpanded,
          roundedCorners: roundedCorners
        }));
      } else if (child.type === ExpandableLabelBody) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          expanded: isExpanded
        }));
      } else {
        return child;
      }
    })
  });
};

ExpandableLabel.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  floating: PropTypes.bool,
  roundedCorners: PropTypes.bool,
  zIndex: PropTypes.number
};
export default ExpandableLabel;